
import { mapGetters } from 'vuex'

export default {
  name: 'MegaMenuSafe',
  data() {
    return {
      list: {},
      menu: new Map(),
      title: '',
    }
  },
  computed: {
    ...mapGetters('menu', [
      'all',
    ]),
  },
  methods: {
    addList(key, list, level, parent) {
      const { length } = Object.keys(this.list)
      for (let x = length; x >= +level; x--) {
        delete this.list[x]
      }
      this.$set(this.list, key, {})
      this.$set(this.list[key], 'list', (this.all.get(parent) || []).filter(el => el.active_product_count))
      this.$set(this.list[key], 'level', level)
      this.$set(this.list[key], 'parent', parent)
      this.menu.set(parent, list)
    },
    addTitle(title) {
      this.title = title
    },
  },
  render() {
    return this.$scopedSlots.default({
      list: this.list,
      add: (key, list, level, parent) => this.addList(key, list, level, parent),
      addTitle: title => this.addTitle(title),
      menu: this.all,
      title: this.title,
    })
  },
}
